define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");

    var KEYS = {
        "URL": "url"
    };

    var ManageDomainsBoxItemModel = {};

    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        ManageDomainsBoxItemModel = BaseModel.extend({
            KEYS:KEYS,
            defaults:{
                url:""
            },
            name: "ManageDomainsBoxItemModel",
            validation:{
                "url":[
                    {
                        required: false,
                        minLength:1,
                        msg:"LEManager.manage.domains.try.valid.url"
                    },
                    {
                        pattern:"certificateCommonName",
                        msg:"LEManager.manage.domains.try.valid.url"
                    }
                ]
            }
        });

    });

    ManageDomainsBoxItemModel.KEYS = KEYS;
    return ManageDomainsBoxItemModel;
});
